module.exports = {
    "crude": {
        "search": "Hledat",
        "actions": "Akce",
        "nextPage": "Další strana",
        "lastPage": "Předchozí stránka",
        "back": "Zadní",
        "empty": "prázdný",
        "edit": "Upravit",
        "create": "vytvořit",
        "data": "záznam",
        "view": "ukázat",
        "delete": "Vymazat",
        "save": "Uložit",
        "cancel": "zrušení",
        "noContent": "Nejsou k dispozici žádné záznamy. ",
        "resetFilter": "Resetujte filtry a zobrazte další obsah!",
        "createOwnTextField": "Vytvořte si vlastní textové pole",
        "textFieldName": "popisek textového pole",
        "textFieldValue": "Obsah",
        "insertTextFieldLabel": "Zadejte název textového pole!",
        "deleteTextField": "Smazat textové pole",
        "success": "Uložit bylo úspěšné",
        "invalidDataFields": "Následující datová pole jsou neplatná:  ",
        "entries": "záznamy",
        "entry": "vstup",
        "tabDetail": "podrobnosti",
        "entity": "entita",
        "of": "z",
        "uploadNewFile": "Nahrát soubor",
        "upload": "nahrát",
        "confirm": "OK",
        "deleteFileQuestion": "Opravdu chcete tento soubor smazat? ",
        "deleteFileQuestionTitle": "Nebezpečí!",
        "deleteEntityQuestion": "Opravdu chcete smazat tuto entitu? ",
        "deleteEntityQuestionTitle": "Nebezpečí!",
        "errorLargeFileUpload": "Vybraný soubor je příliš velký!",
        "useCroppedImage": "Použijte oříznutí",
        "useOriginalImage": "Použijte původní obrázek",
        "available": "dostupný",
        "searchColumn": "najít sloupec",
        "manageColumns": "Správa sloupců",
        "hideColumn": "skrýt sloupec",
        "pinToRight": "Připnout sloupec vpravo",
        "pinToLeft": "Připnout sloupec vlevo",
        "sortAsc": "Seřadit vzestupně",
        "sortDesc": "Seřadit sestupně",
        "hideAll": "všechno schovat",
        "showAll": "Ukázat vše",
        "preview": "náhled",
        "title": "titul",
        "description": "Popis",
        "tooltip": "popis",
        "sort": "seřazeno podle",
        "settings": "Nastavení",
        "incomingReference": "odkaz",
        "language": "Jazyk",
        "deleteTabQuestionTitle": "Nebezpečí!",
        "deleteTabQuestion": "Opravdu chcete smazat tuto kartu? ",
        "deleteElementQuestionTitle": "Nebezpečí!",
        "deleteElementQuestion": "Opravdu chcete tuto položku smazat? ",
        "configurationEditorDescriptionStringLayout": "V tomto sloupci lze vybrat tři varianty pro zadání textu:",
        "configurationEditorDescriptionEnumLayout": "Pro výběr prvků v tomto sloupci lze vybrat dvě varianty:",
        "configurationEditorDescriptionBooleanLayout": "Pro výběr prvků v tomto sloupci lze vybrat dvě varianty:",
        "configurationEditorDescriptionForeignEntityLayout": "Pro výběr prvků v tomto sloupci lze vybrat dvě varianty:",
        "stringLayoutsingleline": "jediný řádek",
        "stringLayoutmultiline": "víceřádkový",
        "stringLayouteditor": "Rich Text Editor",
        "enumLayoutradio": "přepínač",
        "enumLayoutdropdown": "rozevírací seznam",
        "booleanLayoutcheckbox": "zaškrtávací políčko",
        "booleanLayoutswitch": "přepínače",
        "foreignEntityLayoutpopUp": "vyskakovat",
        "foreignEntityLayoutautocomplete": "rozevírací seznam",
        "foreignEntityLayoutlist": "seznam",
        "formatTooltipbold": "Tlustý",
        "formatTooltipitalic": "kurzíva",
        "formatTooltipunderline": "podtrženo",
        "formatTooltipstrike": "Přeškrtnuté",
        "formatTooltipclean": "jasné formátování",
        "formatTooltipcodeBlock": "kód",
        "formatTooltipblockquote": "Citát",
        "formatTooltipcolor": "barva fontu",
        "formatTooltipbackground": "barva pozadí",
        "formatTooltipfont": "písmo",
        "formatTooltipalign": "zarovnání",
        "formatTooltipheader": "velikost písma",
        "formatTooltipsuper": "Horní index",
        "formatTooltipsub": "dolní index",
        "formatTooltipordered": "Objednaný seznam",
        "formatTooltipbullet": "Výčet",
        "true": "Ano",
        "false": "Ne",
        "selectEntity": "vybrat entitu",
        "filter": "filtr",
        "useFilter": "Použijte filtry",
        "defaultFilter": "reset filtru",
        "expand": "rozšířit",
        "hide": "skrýt",
        "minimumSelectionError": "Musí být vybráno alespoň {{min}} položek.",
        "maximumSelectionError": "Lze vybrat maximálně {{max}} záznamů."
    }
}
;